import { useEffect, useState } from 'react';
import { connectCollaboration } from '../collaboration/collaborationSocket';
import { getState, subscribe } from '../collaboration/store';

/**
 * Se suscribe al estado colaborativo sin abrir ningún socket.
 *
 * Lo usan los envoltorios de formulario (`FormScope`), que solo necesitan
 * saber si su formulario está tomado o tiene un conflicto.
 */
export function useCollaborationState() {
  const [state, setState] = useState(getState());
  useEffect(() => subscribe(() => setState({ ...getState() })), []);
  return state;
}

/**
 * Conecta el editor de peritaje a la coordinación colaborativa.
 *
 * Uso:
 *   const collab = useCollaboration(inspectionId);
 *
 * Abre un único WebSocket a `ws/inspection/<id>/` y devuelve el estado
 * re-renderizado: `connected`, `presence`, `locks`, `conflicts`, etc.
 */
export default function useCollaboration(inspectionId) {
  const [state, setState] = useState(getState());

  useEffect(() => subscribe(() => setState({ ...getState() })), []);

  useEffect(() => connectCollaboration(inspectionId), [inspectionId]);

  return state;
}